// TODO: Заменить на настоящий АПИ, когда он будет готов
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { FxIdWebFeaturesFriendsGetFriendsResponseFriendData } from "../gen";
import OpenApiClient from "../OpenApiClient";

export const useFriendsQuery = (
	options?: Omit<
		UseQueryOptions<
			FxIdWebFeaturesFriendsGetFriendsResponseFriendData[],
			unknown,
			FxIdWebFeaturesFriendsGetFriendsResponseFriendData[],
			readonly ["friends"]
		>,
		"queryFn" | "initialData" | "queryKey"
	>
) =>
	useQuery({
		queryKey: ["friends"] as const,
		// TODO: В данный момент API кажется возвращает всех пользователей, а не друзей,
		// так как в FriendsIds передается пустой массив.
		// Это нужно будет исправить, когда API будет готов.
		queryFn: async () =>
			(await OpenApiClient.Friends.fxIdWebFeaturesFriendsGetFriendsEndpoint({ FriendsIds: [] })).Friends,
		...options
	});
